import isNil from 'lodash/isNil'

interface IFormatRateOptions {
  /**
   * Value prepended to input string
   * @example '$'
   * @default '$'
   */
  prefix?: string
  /**
   * Adds digits to the end of the number, i.e. '4.023'
   * @example 4
   * @default 2
   */
  maximumFractionDigits?: number
}

export const formatRate = (
  value: number | null | undefined,
  { maximumFractionDigits = 2, prefix }: IFormatRateOptions = {}
): string | undefined => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined

  const output = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
    minimumFractionDigits: 2,
  }).format(value)

  return isNil(prefix) ? output : `${prefix}${output.replace('$', '')}`
}
